import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { readStyle } from "./indicatorUtils";

export const createOBV = (settings: any) => {
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const obvS = readStyle(styles, "obv", "#2196F3");

  return {
    name: "obv",
    shortName: "OBV",
    calcParams: [] as number[],
    series: "normal" as const,
    figures: [{ key: "obv", title: "OBV: ", type: "line" }],
    styles: {
      lines: [klineLineStyle(obvS.color, 2, lineStyleToKLine(obvS.style))],
    },
    regenerateFigures: () => [{ key: "obv", title: "OBV: ", type: "line" }],
    calc: (dataList: KLineData[]) => {
      const n = dataList.length;
      const results: Array<{ obv?: number }> = new Array(n);
      let obv = 0;

      for (let i = 0; i < n; i++) {
        const vol = dataList[i]!.volume ?? 0;
        if (i === 0) {
          obv = vol;
        } else {
          const prevClose = dataList[i - 1]!.close;
          const curClose = dataList[i]!.close;
          if (curClose > prevClose) obv += vol;
          else if (curClose < prevClose) obv -= vol;
        }
        results[i] = { obv };
      }

      return results;
    },
  };
};
